var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91901 5.93889L7.72375 2.36666C8.24445 1.87778 9.08867 1.87778 9.60937 2.36666L13.4141 5.93889M3.91901 5.93889C3.54407 6.29102 3.33323 6.76876 3.33323 7.26668V12.1222C3.33323 13.1593 4.22866 14 5.33323 14H6.66654M3.91901 5.93889C3.91908 5.93882 3.91894 5.93896 3.91901 5.93889ZM3.91901 5.93889L2.66675 7.11481M13.4141 5.93889C13.7892 6.29104 13.9999 6.76866 13.9999 7.26668V12.1222C13.9999 13.1593 13.1045 14 11.9999 14H10.6665M13.4141 5.93889L14.6666 7.11481M6.66654 14H10.6665M6.66654 14V10.6667C6.66654 9.93029 7.2635 9.33333 7.99988 9.33333H9.33321C10.0696 9.33333 10.6665 9.93029 10.6665 10.6667V14",
    stroke: "#0D0D12",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.60680316e412165d344afd798a3a8869.svg";
export { ForwardRef as ReactComponent };